export default __webpack_public_path__ + "c8cf67879a1d19625f84c1f97a8c9824.svg";